import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "DRY is a footgun, remember to YAGNI",
  "description": "",
  "published": "2019-01-07T00:00:00.000Z",
  "redirect_from": ["/blog/dry-footgun-remember-yagni/swizec/8856"],
  "categories": "Front End, Learning, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`DRY is the first of the big rules engineers learn. Do not Repeat Yourself.`}</p>
    <p>{`It's a good rule. You'll figure it out on your own even if nobody teaches you.`}</p>
    <p><em parentName="p">{`"Make a button"`}</em></p>
    <p>{`Okay, you can write a component like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const Button = () => <button>Button</button>;
`}</code></pre>
    <p><em parentName="p">{`"I want to have a button that says Button and a button that says Click Me"`}</em></p>
    <p>{`You got it!`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const Button = () => <button>Button</button>;

const ClickMe = () => <button>ClickMe</button>;
`}</code></pre>
    <p><em parentName="p">{`"Now I want Button to open the shopping cart and I want ClickMe to close the page."`}</em></p>
    <p>{`Okay, we can do that.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const Button = () => <button onclick={openCart}>Button</button>;

const ClickMe = () => <button onclick={closePage}>ClickMe</button>;
`}</code></pre>
    <p><em parentName="p">{`"Wonderful. Beautiful buttons. I want a third button, and this one should close the currently open modal."`}</em></p>
    <p>{`Ah, this is getting tedious. Are you going to want many more buttons?`}</p>
    <p><em parentName="p">{`"Yeah, maybe?"`}</em></p>
    <p>{`Okay. Let me DRY this up.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const GenericButton = ({ onClick, label }) => (
    <button onclick={onClick}>{label}</button>
)

const Button = () => (
    <genericbutton onclick={openCart} label="Button">
)

const ClickMe = () => (
    <genericbutton onclick={closePage} label="ClickMe">
)

const CloseModal = () => (
    <genericbutton onclick={closeModal} label="Close Modal">
)
</genericbutton></genericbutton></genericbutton>
`}</code></pre>
    <p><em parentName="p">{`"Wonderful. Can we make all those buttons 20px font?"`}</em></p>
    <p>{`Yes, of course!`}</p>
    <p>{`You've just DRY'd up your code, and here's your first victory. Buttons use a common underlying component. Giving them all a big font is easy. You got dis.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const GenericButton = ({ onClick, label }) => (
    <button 20="" onclick={onClick} style={{ fontsize: }}>
        {label}
    </button>
)
`}</code></pre>
    <p>{`All your buttons now have a bigger font. DRY Magic.`}</p>
    <p><img parentName="p" {...{
        "src": "/9a021a6cd72cfaab539f3b1fef648ed9/media-12NUbkX6p4xOO4-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`A true victory for engineering. You pat yourself on the back for an architecture well designed, code cleaned up. You followed some great engineering principles! 👏`}</p>
    <p><strong parentName="p">{`But you just shot yourself in the foot.`}</strong></p>
    <p>{`Next week, your PM comes back and says, `}<em parentName="p">{`"Button must be green, ClickMe should be blue, and CloseModal is red"`}</em></p>
    <p>{`Okay, that's annoying, why 3 different buttons, but you can extend `}<inlineCode parentName="p">{`GenericButton`}</inlineCode>{` to accept styling. You've still got dis.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const GenericButton = ({ onClick, label, style }) => (
    <button onclick={onClick} style={{ fontsize: 20, ...style }}>
        {label}
    </button>
)

const Button = () => (
    <genericbutton onclick={openCart} label="Button" style={{ background: 'green' }}>
)

const ClickMe = () => (
    <genericbutton onclick={closePage} label="ClickMe" style={{ background: 'blue' }}>
)

const CloseModal = () => (
    <genericbutton onclick={closeModal} label="Close Modal" style={{ background: 'green' }}>
)
</genericbutton></genericbutton></genericbutton>
`}</code></pre>
    <p>{`You had to add styles to every call of `}<inlineCode parentName="p">{`GenericButton`}</inlineCode>{`, but that's okay. At least you have components so you didn't have to find every single invocation of any button and change them.`}</p>
    <p>{`That's the power of DRY. Change once, fix everywhere.`}</p>
    <p>{`Then your PM says `}<em parentName="p">{`"The font on CloseModal is too big"`}</em></p>
    <p>{`A-ha! You were smart. You wrote `}<inlineCode parentName="p">{`GenericButton`}</inlineCode>{` so styles provided through props can overwrite default styles.`}</p>
    <p><inlineCode parentName="p">{`{{ fontSize: 20, ...style }}`}</inlineCode>{` versus `}<inlineCode parentName="p">{`{{ ... style, fontSize: 20 }}`}</inlineCode>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "/8939e4fc04b35c2173741bcf98edb3e4/media-d3mlE7uhX8KFgEmY-giphy.gif",
        "alt": null
      }}></img></p>
    <p><em parentName="p">{`"CloseModal and Button should be disabled when they're inactive"`}</em></p>
    <p>{`Hmm… 2 of your 3 buttons need new behavior. Best add it to the base implementation.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const GenericButton = ({ onClick, label, active, style }) => (
  <button onclick={onClick} disabled style={{ fontsize: 20, ...style }}>
    {label}
  </button>
);
`}</code></pre>
    <p>{`You change `}<inlineCode parentName="p">{`Button`}</inlineCode>{` and `}<inlineCode parentName="p">{`ClickMe`}</inlineCode>{` to set the `}<inlineCode parentName="p">{`active`}</inlineCode>{` prop based on some state.`}</p>
    <p>{`And `}<inlineCode parentName="p">{`ClickMe`}</inlineCode>{` became disabled too? That's weird.`}</p>
    <p>{`Guess you have to change that one so it's always passing `}<inlineCode parentName="p">{`active=true`}</inlineCode>{`. That's weird.`}</p>
    <p>{`Why would a button always proclaim itself as active? Buttons should be active by default, and this feature should exist only for buttons that use it.`}</p>
    <p>{`You adapt the code.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const GenericButton = ({ onClick, label, active, style }) => {
  active = active === undefined ? true : active;

  return (
    <button onclick={onClick} disabled style={{ fontsize: 20, ...style }}>
      {label}
    </button>
  );
};
`}</code></pre>
    <p>{`Now `}<inlineCode parentName="p">{`active`}</inlineCode>{` is `}<inlineCode parentName="p">{`true`}</inlineCode>{` when undefined, and whatever you set otherwise.`}</p>
    <h2 {...{
      "id": "the-dry-footgun"
    }}>{`The DRY footgun`}</h2>
    <p>{`Your `}<inlineCode parentName="p">{`GenericButton`}</inlineCode>{` is starting to swell with edge cases. As time passes, it's going to get worse and worse.`}</p>
    <p>{`You'll add a loading state. But only some buttons will use it. You'll add hover/unhover behavior. But not all buttons want that.`}</p>
    <p>{`Eventually, you'll have a button with so many features it's impossible to use. Every render requires so many props that you might as well write a whole button from scratch.`}</p>
    <p>{`Happens a lot.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`When it starts having a general purpose. The amount of times I shot myself in the foot by generalizing too early is too damn high`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1081328297634459649"
      }}>{`January 4, 2019`}</a></blockquote>
    <h2 {...{
      "id": "yagni-to-the-rescue"
    }}>{`YAGNI to the rescue`}</h2>
    <p><a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/You_aren't_gonna_need_it"
      }}>{`YAGNI`}</a>{`, ya ain't gonna need it, is a programming philosophy that engineers learn a little later in life.`}</p>
    <p>{`Because it takes a while for those DRY footguns to appear, perhaps. Or because many projects don't live long enough to see it. Maybe it's just a matter of thinking about why your code is suffering.`}</p>
    <p>{`YAGNI often comes in 2 shapes 👇`}</p>
    <p><strong parentName="p">{`The first`}</strong>{` is like the above. You spotted an opportunity to optimize, but you were too early. You should avoid generalizing code until it is absolutely obvious that you should.`}</p>
    <p>{`The more use-cases you have, the easier to know what to generalize. I mean, how can you know which functionality your components share if you don't even have those components yet?`}</p>
    <p>{`You can't.`}</p>
    <p>{`And that brings us to `}<strong parentName="p">{`the other YAGNI`}</strong>{`: Building stuff you think you'll need before you need it.`}</p>
    <p>{`You think of a wonderful abstraction. A wonderful little feature that's gonna help oh so much in the future.`}</p>
    <p>{`You build it.`}</p>
    <p>{`Months pass. You tweak the code here and there. Nobody's using it, but you have to maintain otherwise it's gonna break. Whenever you implement a feature, you have to think about how it impacts this code you've got.`}</p>
    <p>{`It's slowing you down. Making you think. And you aren't even using it.`}</p>
    <p>{`But one day! One glorious day, your PM gives you a task. A task from the gods. You are about to use this code you predicted 6 months ago!`}</p>
    <p>{`You are a god of prediction! You knew it all along!`}</p>
    <p><img parentName="p" {...{
        "src": "/3990907c9d9e84dd1b2482fa40854cb3/media-ibGFpMv1Uoais-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`You delete your code and start from scratch. The feature is so different that you can't use any of it.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      